import { render, staticRenderFns } from "./InputWithLabel.vue?vue&type=template&id=1a73d8a0&scoped=true"
import script from "./InputWithLabel.vue?vue&type=script&lang=js"
export * from "./InputWithLabel.vue?vue&type=script&lang=js"
import style0 from "./InputWithLabel.vue?vue&type=style&index=0&id=1a73d8a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a73d8a0",
  null
  
)

export default component.exports